import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  viewBox: "0 0 21 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M10.39 0C.179 0 0 .908 0 8s.179 8 10.39 8c10.21 0 10.39-.908 10.39-8s-.18-8-10.39-8Zm3.33 8.347-4.665 2.178c-.409.189-.743-.023-.743-.474V5.949c0-.45.334-.663.743-.474l4.664 2.178c.409.191.41.503.001.694Z"
    }, null, -1)
  ])))
}
export default { render: render }